import {
  createAsyncThunk, createSelector,
  createSlice,
  PayloadAction
} from '@reduxjs/toolkit';
import API from '../../../api/api';
import { LoadingStatus } from '../../../models/slice.models';

export const RESET_PASSWORD_FEATURE_KEY = 'resetPassword';

export interface ResetPasswordState {
  loadingStatus: LoadingStatus;
  error?: string;
}

export const requestPasswordToken = createAsyncThunk(
  'resetPassword/requestPasswordToken',
  async (data: any, thunkAPI) => {
    const response = await API.user().requestPassword(data);
    return response?.data;
  }
);

export const resetPassword = createAsyncThunk(
  'resetPassword/resetPassword',
  async (data: any, thunkAPI) => {
    try {
      const response = await API.user().resetPassword(data);
      if (response) {
        return thunkAPI.fulfillWithValue(response.data);
      } else {
        throw thunkAPI.rejectWithValue('error');  
      }
    } catch (err: any) {
      throw thunkAPI.rejectWithValue(err.response);
    }
  }
);

export const initialResetPasswordState: ResetPasswordState = {
  loadingStatus: LoadingStatus.NOT_LOADED,
  error: '',
};

export const _resetPasswordSlice = createSlice({
  name: RESET_PASSWORD_FEATURE_KEY,
  initialState: initialResetPasswordState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(requestPasswordToken.pending, (state: ResetPasswordState) => {
        state.loadingStatus = LoadingStatus.LOADING;
      })
      .addCase(
        requestPasswordToken.fulfilled,
        (state: ResetPasswordState, action: PayloadAction<any>) => {
          state.loadingStatus = LoadingStatus.LOADED;
        }
      )
      .addCase(
        requestPasswordToken.rejected,
        (state: ResetPasswordState, action) => {
          state.loadingStatus = LoadingStatus.ERROR;
          state.error = action.error.message;
        }
      );
  },
});

/*
 * Export reducer for store configuration.
 */
export const resetPasswordReducer = _resetPasswordSlice.reducer;

export const resetPasswordActions = _resetPasswordSlice.actions;

export const getResetPasswordState = (rootState: any): ResetPasswordState =>
  rootState[RESET_PASSWORD_FEATURE_KEY];

export const resetPasswordState = createSelector(
  getResetPasswordState,
  (state) => state
);
